import styled, { RuleSet } from 'styled-components';

interface Props {
  private?: boolean;
}
export const withPrivacy = <T extends React.ComponentType<any>>(
  BaseComponent: T,
  overrides: RuleSet<Props>,
) => {
  return styled(BaseComponent)<Props>`
    ${(props) => (props.private ? overrides : '')};
  `;
};
// check styles
